// Main
export const ROOT = '/';
export const PRODUCT = '/product';
export const INDUSTRY = '/industry';
export const POST = '/news';
export const ABOUT = '/about';
export const ABOUTUS = '/about-us';
export const RMS_GIVES = '/rms-gives';
export const CONTACT = '/contact';
export const REQUEST_DEMO = '/request-demo';

// Footer
export const CAREERS = '/careers';
export const PCI_COMPLIANCE = '/pci-compliance';
export const PRIVACY_POLICY = '/privacy-policy';
export const REFERRAL_PROGRAM = '/referral-program';
export const USER_LICENSE = '/user-license';

// Product
export const PRODUCT_RMS_PRO = PRODUCT + '/pms';
export const PRODUCT_RMS_POS = PRODUCT + '/pos';
export const PRODUCT_FEATURES = PRODUCT;
export const PRODUCT_RESOURCES = PRODUCT + '/resource';
export const PRODUCT_INTERFACES = PRODUCT + '/interface';
export const PRODUCT_DEVELOPERS = PRODUCT + '/developer';
export const PRODUCT_SUPPORT = 'https://helpcentre.rmscloud.com/';

// Industry
export const INDUSTRY_HOTEL = INDUSTRY + '/hotel-reservation-system';
export const INDUSTRY_RV_PARK = INDUSTRY + '/rv-park-software';
export const INDUSTRY_CAMPGROUND = INDUSTRY + '/campground-software';
export const INDUSTRY_MARINA = INDUSTRY + '/marina-management-software';

// ABOUT
export const TEAM = '/team';
export const PARTNER_WITH_US = '/partner-with-us';

// Contact
export const CONTACT_AUSTRALIA_ASIA = 'https://www.rmscloud.com/about-us/contact-us/australia/';
export const CONTACT_NEW_ZEALAND = 'https://www.rmscloud.com/about-us/contact-us/new-zealand/';
export const CONTACT_INDIA = 'https://www.rmscloud.com/about-us/contact-us/india/';
export const CONTACT_MIDDLE_EAST = 'https://www.rmscloud.com/about-us/contact-us/middle-east/';
export const CONTACT_UK_IRELAND = 'https://www.rmscloud.com/about-us/contact-us/uk-and-ireland/';

// Account
export const LOG_IN = 'https://app.rmscloud.com/Login';
export const LOG_IN_RMS_NINE = 'https://web.rmscloud.com/';
export const LOG_IN_RMS_NINE_PLUS = 'https://app.rmscloud.com/Login';
export const CUSTOMER_SUPPORT_CENTER = 'http://support.rms.com.au';
export const REMOTE_ASSISTANCE = 'http://remote.rms.com.au/';
export const PAY_BILL = 'https://subscriptions.zoho.com/portal/rmsna/login';
